module.exports = __webpack_public_path__ + "img/11.330e7c51.png";